import { StyleSheet } from "@react-pdf/renderer";

const createMetaItems = (fontSize?: number) => ({
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    color: "#939496",
    ...(fontSize && { fontSize }),
}) as any;

export const styles = StyleSheet.create({
    container: {
        borderWidth: 1,
        borderColor: "#e3e3e6",
        borderRadius: 5,
        padding: 10,
        marginBottom: 10,
        height: "100%",
    },
    title: {
        color: "black",
        fontFamily: "Poppins-Medium",
        fontSize: 14,
        fontWeight: "bold",
        marginBottom: 10
    },
    metaItemContainer: {},
    metaItems: createMetaItems(),
    metaItemsIntakeReport: createMetaItems(9),
    metaTextValue: {
        color: "#4f4f4f",
        fontWeight: "bold",
        fontSize: 9,
        textAlign: "right",
        maxWidth: "70%",
    },
    metaTextValueIntakeReport: {
        color: "#4f4f4f",
        fontWeight: "bold",
        marginBottom: 8,
        maxWidth: "70%",
    },
    image: {
        width: 110,
    },
    metaContainer: {
        width: "100%",
    },
    notes: {
        marginTop: 10,
        fontSize: 8,
        lineHeight: 1.1,
        backgroundColor: "#f0f0f0",
        padding: 8
    },
    items: {
        flexDirection: "row",
        marginTop: 10,
        justifyContent: "space-between",
        fontSize: 14,
    },
    itemOveralDecision: {
        color: "black",
        flexDirection: "row",
        fontFamily: "Poppins-Medium",
        marginTop: 20,
        alignContent: "center",
        alignItems: "center",
        justifyContent: "space-between",
    },
});
